<!-- TODO add default image when user is not login. -->
<div *ngIf="avatar$ | async; else avatarIcon" style="height: 100%">
    <div
        class="avatar-img"
        #img
        [style.background-image]="'url(' + (avatar$ | async) + ')'"
    >
    </div>
</div>

<ng-template #avatarIcon>
	<div class="avatar-img" #img>
		<serviceos-ng-system-icon
            class="d-block"
            [ngStyle]="{ 'font-size.px': iconHight }"
            [icon]="'account-contact-details'"
        >
    </serviceos-ng-system-icon>
	</div>
</ng-template>

<!-- -->
